import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import type { Dispatch, SetStateAction } from 'react';

interface Props {
  isvideoPopup: boolean;
  setvideoPopup: Dispatch<SetStateAction<any>>;
  src: string;
}
const VideoPopup = (props: Props) => {
  const handleClose = () => {
    props.setvideoPopup(false);
  };
  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={props.isvideoPopup}
      onClose={handleClose}
      aria-labelledby=""
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Tooltip title="Close" arrow>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </DialogTitle>
      <DialogContent
        sx={{
          borderTop: '0px solid rgba(145, 158, 171, 0.24)',
          pt: '16px !important',
        }}
      >
        <Box
          component="iframe"
          width="100%"
          // src="https://www.youtube.com/embed/eqkSWv96b2U?autoplay=1&rel=0"

          src={props.src}
          title="TaxZerone"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen={true}
          sx={{ height: { xs: '100%', sm: 375, md: 650 } }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default VideoPopup;
